// AGC: Empty module stub for incompatible packages
// AGC: Used in vite.config.ts to alias problematic imports
export default {}

// AGC: Provide a harmless stub for Farcaster connector so desktop bundles can import safely.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const farcasterMiniApp = (..._args: any[]): any => {
  console.warn('AGC: Using Farcaster connector stub (desktop bundle).')
  return {
    id: 'farcaster-mini-app-stub',
    name: 'Farcaster Mini App (stub)',
    type: 'mock',
    connect: async () => {
      throw new Error('AGC: Farcaster connector is unavailable in desktop context.')
    },
    disconnect: async () => {},
  }
}

